"use client";

import { Icon } from "@perceptron/ui/components/icon";
import { cn } from "@perceptron/utils/cn";

const Logo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <>
      <Icon {...props} className={cn("block dark:hidden", props.className)} name="logo-dark" />
      <Icon {...props} className={cn("hidden dark:block", props.className)} name="logo-light" />
    </>
  );
};

export default Logo;
